module.exports = "pegasus/assets/themelp1/large/41.png";